import { getFileNameFromResponse } from '$core/helpers/get-filename-from-header';
import { openBlobInNewTab } from '$core/helpers/open-blob-in-new-tab';
import { saveBlob } from '$core/helpers/save-blob';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BatchDocumentsService {
  private readonly http = inject(HttpClient);

  public download(documentId: number): Observable<HttpResponse<Blob>> {
    const url = `/v1/batch-mailing/documents/${documentId}/download`;
    return this.http
      .get(url, { observe: 'response', responseType: 'blob' })
      .pipe(
        tap((res) => {
          if (!res.body) return;

          const mimeType = res.body.type;
          const browserViewableMimeTypes = [
            'application/pdf',
            'image/png',
            'image/jpeg',
            'image/gif',
            'image/webp',
            'image/svg+xml',
            'text/plain',
            'text/html',
          ];

          if (browserViewableMimeTypes.includes(mimeType)) {
            openBlobInNewTab(res.body);
          } else {
            const fileName = getFileNameFromResponse(res, 'document');
            void saveBlob(res.body, fileName);
          }
        })
      );
  }
}
